'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const EmptyStatusIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} strokeDasharray="4 4" /></svg>);